import React from 'react';
import SearchAndTable from '../components/SearchAndTable';
import Editpopup from '../articlecontent/Editpopup';
import { sortData,} from '../components/SortFunctions.js';
import GridContainer from "../components/Grid/GridContainer.jsx";
import GridItem from "../components/Grid/GridItem.jsx";
import { makeStyles,Tooltip,Button } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import Select from "./MultiSelect";
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash';

        const COLOR = "rgba(74, 74, 74, 1)";
        const greenColor='green';

const useStyles = makeStyles(() => ({
    patientName: { fontSize: "14px", maxWidth: 150, color: COLOR, },
    fourlinecss: { MaxWidth: " 175px", overflow: "hidden", position: "relative", lineHeight: "1.2em", maxHeight: "4.85em", marginRight: "-1em", paddingRight: 1, paddingTop: "2px", paddingBottom: "2px", },
    lightTooltipTimeToTake: { maxWidth: 150, minWidth: 150, color: COLOR, fontSize: 12, border: '1px solid #dadde9', boxShadow: "0px 1px 0px -6px rgba(0,0,0,0.2), 0px 1px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)" },
    adherencePopBdy: { padding: "1px", },
    git: { color: COLOR, fontSize: "8px" },
    dFlex:{display:'flex'},
    checkicon: { color: "green", paddingTop: "10px"},
  createUserSelect: {
                "& p": {
                        minWidth:"100px",maxWidth: "200px", textOverflow: "ellipsis",
                        display: "inline-block", overflow: "hidden", whiteSpace: "nowrap !important",
                }
        }
}));

const Commondashboard = (props) => {
const [rowdata,setRowdata]=React.useState([]);
const[versiondata,setVersiondata]=React.useState([]);
const[versionoptiondata,setVersionoptiondata]=React.useState([]);
const COLOR = "rgb(177, 2, 34)";
const handlechangeVersion=(value,contentname)=>{
setVersiondata({...versiondata,[contentname.name]:value});
};
const handleUnDeleteUser=(resourceid,name,versionnumber,versionlength,status,clone )=>{
let newversion=true;
if((status === "Approved"&& versionnumber === versionlength)){
newversion=false;
}
props.handleEditUser(resourceid, name, versionnumber,clone,newversion);
};
const handleaction=( resourceidCB, handleEditUserCB,handlepreviewCB,statusCB,handleDeleteUserCB, nameCB,
                versionnumberCB,versionlengthCB, revisonCB, deletevalueCB,delvalue,jirastatus)=>{
                    if((delvalue===1)&&(jirastatus==='Approved')){
                        if(versionnumberCB!==versionlengthCB){
                    return <p style={{ color: COLOR,paddingTop:10 }}>Deleted</p>;
                    }
                        else{
                            return <div className={classes.dFlex}><p style={{ color: COLOR,paddingTop:10 }}>Deleted</p>
                                <Button  onClick={() =>handleUnDeleteUser(resourceidCB,`version-${versionnumberCB}`,versionnumberCB,versionlengthCB,statusCB)} style={{ color:greenColor}}>
                                <Tooltip  placement="top" arrow classes={{ tooltip: classes.lightTooltipTimeToTake + " " + "displayMedicationToolTipArrow"}}
                                title={<GridContainer className={classes.adherencePopBdy}>
                                <GridItem md={10} style={{color:"#fff",textAlign:"center"}}>Click to Undelete</GridItem></GridContainer>}>
                                <RestoreFromTrashIcon className={classes.btnIcon} style={{ color: greenColor }} /></Tooltip>
                                </Button></div>;
                            }
                        }
                    else if((delvalue===1)&&(jirastatus!=='Approved')){
                        return <p>Requested to Delete</p>;
                        }
                    else{
                    return  <Editpopup resourceid={resourceidCB} handleEditUser={handleEditUserCB} 
                                handlepreview={handlepreviewCB} status={statusCB}handleDeleteUser={handleDeleteUserCB} name={nameCB} 
                                versionnumber={versionnumberCB}  versionlength={versionlengthCB} revison={revisonCB} deletevalue={deletevalueCB}/>;
                    }
                // if((delvalue.lastIndexOf(1)+1>=versionnumberCB)&&(delvalue.lastIndexOf(1)!==-1)&&(jirastatus==='Approved')){
                //     if(versionnumberCB!==versionlengthCB){
                //         return <p style={{ color: COLOR,paddingTop:10 }}>Deleted</p>;
                //     }
                //     else{
                //         return <div className={classes.dFlex}><p style={{ color: COLOR,paddingTop:10 }}>Deleted</p>
                //         <Button  onClick={() =>handleUnDeleteUser(resourceidCB,`version-${versionnumberCB}`,versionnumberCB,versionlengthCB,statusCB)} style={{ color:greenColor}}>
                //         <Tooltip  placement="top" arrow classes={{ tooltip: classes.lightTooltipTimeToTake + " " + "displayMedicationToolTipArrow"}}
                //         title={<GridContainer className={classes.adherencePopBdy}>
                //         <GridItem md={10} style={{color:"#fff",textAlign:"center"}}>Click to Undelete</GridItem></GridContainer>}>
                //         <RestoreFromTrashIcon className={classes.btnIcon} style={{ color: greenColor }} /></Tooltip>
                //         </Button></div>;
                //         }
                //     }
                // else if((delvalue.lastIndexOf(1)+1>=versionnumberCB)&&(delvalue.lastIndexOf(1)!==-1)&&(jirastatus!=='Approved')){
                //         if((delvalue.lastIndexOf(1)+1>=versionnumberCB)&&(delvalue.lastIndexOf(1)!==-1)&&(delvalue[delvalue.length-1]===0)){
                //             if(versionnumberCB<=delvalue.lastIndexOf(1)+1){
                //             return <p style={{ color: COLOR,paddingTop:10 }}>Deleted</p>;
                //             }
                //             else{
                //                     return  <Editpopup resourceid={resourceidCB} handleEditUser={handleEditUserCB} 
                //                 handlepreview={handlepreviewCB} status={statusCB}handleDeleteUser={handleDeleteUserCB} name={nameCB} 
                //                 versionnumber={versionnumberCB}  versionlength={versionlengthCB} revison={revisonCB} deletevalue={deletevalueCB}/>;
                //                 }}
                //         else {
                //                 return <p>Requested to Delete</p>;}
                //     }
                // else{
                //     return  <Editpopup resourceid={resourceidCB} handleEditUser={handleEditUserCB} 
                //                 handlepreview={handlepreviewCB} status={statusCB}handleDeleteUser={handleDeleteUserCB} name={nameCB} 
                //                 versionnumber={versionnumberCB}  versionlength={versionlengthCB} revison={revisonCB} deletevalue={deletevalueCB}/>;
                //     }
};
    React.useEffect(() => {
        props.patientList.forEach((item) => {
        let datasend=[];
            let versiondataoption=props.patientList.filter((version)=>version.resourceid===item.resourceid);
            versiondataoption.map((data)=> datasend.push({label:`Version ${data.versionNumber}`,value:data.versionNumber}));
        versionoptiondata[item.resourceid]=datasend;
        setVersionoptiondata({...versionoptiondata});
});
        props.patientList.forEach((item) => {
            let length=versionoptiondata[item.resourceid].length;
            versiondata[item.resourceid]=versionoptiondata[item.resourceid][length-1];
            setVersiondata({...versiondata});
            let versiondatashown=props.patientList.filter((version)=>version.resourceid===item.resourceid);
            let sqlstatuslist=[],sqlRepoUrllist=[],questionlist=[],responsebodylist=[],jirastatuslist=[],jiralinklist=[],jiraAssigneelist=[],
            imageStatuslist=[],deleted=[],imageRepoUrllist=[];
            versiondatashown.map((datashown) => {
                if (props.name === "trivia") {
                    questionlist.push(datashown.content.question);
                    responsebodylist.push(datashown.content.responsebody);
                }
                if (props.name === "curriculum") {
                    questionlist.push(datashown.content.coursetitle);
                    responsebodylist.push(datashown.content.introductionmessage);
                }
                if (props.name === "afb") {
                    questionlist.push(datashown.content.messagetitle);
                    responsebodylist.push(datashown.content.messagebody);
                }
                if (props.name === "meditation") {
                    questionlist.push(datashown.title[0]);
                    responsebodylist.push(datashown.content.responsetitle);
                }
                if (props.name === "article") {
                    questionlist.push(datashown.title[0]);
                    responsebodylist.push(datashown.content.shortDescription);
                }
                sqlstatuslist.push(datashown.sqlStatus); sqlRepoUrllist.push(datashown.sqlRepoUrl); imageStatuslist.push(datashown.imageStatus); imageRepoUrllist.push(datashown.imageRepoUrl);
                if (datashown.jirametadata == null || datashown.jirametadata.fields == null || datashown.jirametadata.fields.status == null) {
                    jirastatuslist.push("Unavailable");
                    jiralinklist.push("");
                } else {
                    jirastatuslist.push(datashown.jirametadata.fields.status.name);
                    jiralinklist.push(datashown.jiradata.key);
                }
                if (datashown.jirametadata == null || datashown.jirametadata.fields == null || datashown.jirametadata.fields.assignee == null) {
                    jiraAssigneelist.push("Unassigned");
                } else {
                    jiraAssigneelist.push(datashown.jirametadata.fields.assignee.displayName);
                }
                if(datashown.isdeleted===0||datashown.isdeleted===1){
                    deleted.push(datashown.isdeleted)
                }
            });
            if (props.name === "trivia" || props.name === "afb") {
                item.name = { resourceid: item.resourceid, github: sqlstatuslist, githubimage: '', gitsqlRepoUrl: sqlRepoUrllist, githubimageRepoUrl: '' };
            } else {
                item.name = { resourceid: item.resourceid, github: sqlstatuslist, githubimage: imageStatuslist, gitsqlRepoUrl: sqlRepoUrllist, githubimageRepoUrl: imageRepoUrllist };
            }
            item.Title = { title: questionlist, resourceid: item.resourceid };
            item.Message = { Message: responsebodylist, resourceid: item.resourceid };
            item.Version = { resourceid: item.resourceid ,newversion:versionoptiondata[item.resourceid].length};
            item.JiraTicket = { jirastatus: jirastatuslist, jiralink: jiralinklist, resourceid: item.resourceid };
            item.Action = { resourceid: item.resourceid, jirastatus: jirastatuslist ,revison:item.revisionNumber,Deleted:deleted};
            item.Assignee = { jiraAssignee: jiraAssigneelist, resourceid: item.resourceid };
            item.Deleted={Deleted:deleted}
        });
        let uniqueresouresid = [...new Map(props.patientList.map(item => [item.resourceid, item])).values()];
        let sorteddata = uniqueresouresid.sort(function (a, b) {
            return b.id - a.id;
        });
        setRowdata(sorteddata);
    }, [props.patientList]);
    function customSort(data, col, order) {
        if (col === 0) {
            return sortData(data, col, order, false);
        } else if (col === 3) {
            return sortData(data, col, order, false);
        } else if (col === 4) {
            return sortData(data, col, order, false);
        } else {
            return sortData(data, col, order, true);
        }
    }
 let triviatableheads = [
        {
            name: "name",
            label: "Content Id",
            options: {
                filter: true,
                sort: true,
                searchable: true,
                hint: false,
                customBodyRender: (value) => {
                return (
                <div style={{ margin: "20px 0", minWidth: 142 }}>
                <p className={classes.patientName}>
                <b className={classes.patientName} >{`${value.resourceid}`}</b><br/></p>
                {value.github[versiondata[value.resourceid].value-1]&&(value.gitsqlRepoUrl[versiondata[value.resourceid].value-1]!==null)?<p className={classes.git}>
                <a href={value.gitsqlRepoUrl[versiondata[value.resourceid].value-1]} target="_blank">{"Script committed in Github"}</a>
                < CheckIcon className={classes.checkicon}/></p>:""}
                {value.githubimage[versiondata[value.resourceid].value-1]&&(value.githubimageRepoUrl[versiondata[value.resourceid].value-1]!==null)?<p className={classes.git}>
                <a href={value.githubimageRepoUrl[versiondata[value.resourceid].value-1]} target="_blank">{"Resources committed in Github"}</a>
                < CheckIcon className={classes.checkicon}/></p>:""}
                </div>
                );
                }
            }
        },
        {   name: "Title",
            label: props.name==="trivia"?"Question":"Title",
            options: {
                filter: false,
                sort: false,
                searchable: true,
                hint: false,
                customBodyRender: (value) => {
                    return (
                        <div className={classes.fourlinecss}>
                            <p className={classes.patientName}>
                                <b>{value.title[versiondata[value.resourceid].value-1]}</b>
                            </p>
                        </div>
                    );
                }
            }
        },
        (props.name!=="meditation")?
        {
            name: "Message",
            label:props.name==="article" ?"Short Description":"Message",
            options: {
                filter: false,
                sort: false,
                searchable: true,
                customBodyRender: (value) => {
                    return (
                        <div  className={classes.fourlinecss}>
                        <p className={classes.patientName}>
                        {`${value.Message[versiondata[value.resourceid].value-1]}`}
                        </p>
                    </div>
                    );
                }
            }
        }:"",
        {
            name: "Version",
            label:"Version",
            options: {
                filter: false,
                sort: false,
                searchable: true,
                customBodyRender: (value) => {
                    return (
            <Select
            value={versiondata[value.resourceid]}
            onChange={(e,name)=>handlechangeVersion(e,name)}
            className={classes.createUserSelect + " " + "selectstyle"}
            options={versionoptiondata[value.resourceid]}
            name={value.resourceid}
            isSearchable = {false}
            isDisabled={versionoptiondata[value.resourceid].length>1?false:true}
            textFieldProps={{
            variant: "filled",
            }}
            placeholder=""
            isClearable={false}
            styles={{
            menuPortal: (base) => ({ ...base, zIndex: 99999 }),
            dropdownIndicator: (provided, state) => ({
                ...provided,
                transform: state.selectProps.menuIsOpen && 'rotate(180deg)'
            })
            }}
        />
                    );
                }
            }
        },
        {
            name: "JiraTicket",
            label: "Jira Details",
            options: {
                filter: false,
                sort: true,
                searchable: true,
                customBodyRender: (value) => {
                return (
                <p className={classes.patientName}>
                <b className={classes.patientName} style={{paddingLeft:"3px",color:"blue"}}>{value.jirastatus[versiondata[value.resourceid].value-1]!=="Unavailable"?
                <Tooltip  placement="top" arrow classes={{ tooltip: classes.lightTooltipTimeToTake + " " + "displayMedicationToolTipArrow"}}
                title={<GridContainer className={classes.adherencePopBdy}>
                <GridItem md={10} style={{color:"#fff",textAlign:"center"}}>Click to go to Jira</GridItem></GridContainer>}>
                <a href={`https://amalgamrx.atlassian.net/browse/${value.jiralink[versiondata[value.resourceid].value-1]}`} target="_blank">{`${value.jirastatus[versiondata[value.resourceid].value-1]}`}</a></Tooltip>:`${value.jirastatus[versiondata[value.resourceid].value-1]}`}</b>
                </p>
                    );
                }
            }
        },
        {
            name: "Assignee",
            label: "Assignee",
            options: {
                filter: false,
                sort: true,
                searchable: true,
                customBodyRender: (value) => {
                    return (
                        <>
                        <p className={classes.patientName}>
                        <b className={classes.patientName} >{`${value.jiraAssignee[versiondata[value.resourceid].value-1]}`}</b>
                        </p>
                    </>
                    );
                }
            }
        },
        {
            name: "Action",
            label: " ",
            options: {
                filter: false,
                sort: false,
                print: false,
                customBodyRender: (value) => {
                return (
                <>
                {handleaction(value.resourceid,props.handleEditUser,props.handlepreview,value.jirastatus[versiondata[value.resourceid].value-1],props.handleDeleteUser,props.name,
                versiondata[value.resourceid].value,versionoptiondata[value.resourceid].length,value.revison,value.Deleted[value.Deleted.length-1],value.Deleted[versiondata[value.resourceid].value-1],value.jirastatus[versiondata[value.resourceid].value-1])}
                </> );
                }
            }
        }
    ];
 const classes = useStyles();
  return(
    <SearchAndTable patientList = {rowdata} reqAttentionFilter={props.reqAttentionFilter}
    columns = {triviatableheads} customSort={customSort} tableContent="patientList"  handleAddNewPatient={props.handleAddNewPatient}/>
    );
  };


export default Commondashboard;